import React from 'react'
import styled from '@emotion/styled'
import {ContentHotel} from '@findhotel/sapi'
import {CallToBook} from 'components/CallToBook'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Box} from '@vio/atlas/helpers/Box'
import {NoStyleButton} from '@vio/atlas/helpers/NoStyleButton'
import {StarRating} from '@vio/atlas/StarRating'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {ReviewRating} from '@vio/shared/src/search/ReviewRating'

const StarsSpacer = styled.span`
  display: inline-block;
  width: ${cssTheme.layout.spacing.s400};
`

const ReviewRatingButton = styled(NoStyleButton)`
  align-items: center;
  justify-content: flex-start;
`

interface Props {
  hotel: ContentHotel
  onReviewSummaryClick: () => void
}

export const HotelTitleBlock: React.FC<Props> = ({
  hotel,
  onReviewSummaryClick
}) => {
  const reviewRating = hotel.guestRating?.overall
  const {isDesktopXs} = useDeviceLayout()

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="s300"
      flex="1"
      minWidth="0"
      data-id="HotelTitleBlock"
    >
      <Text variant="titleXL" dataId="HotelName" tag="h1">
        {hotel.hotelName}
        <StarsSpacer />
        <StarRating
          size="xs"
          data-id="StarRating"
          rating={hotel.starRating}
          isInline
        />
      </Text>
      <Box
        display="flex"
        flexDirection={isDesktopXs ? 'column' : 'row'}
        alignItems={isDesktopXs ? 'flex-start' : 'center'}
        gap="s500"
      >
        {reviewRating && (
          <ReviewRatingButton onClick={onReviewSummaryClick}>
            <ReviewRating
              underlineSubLabel
              rating={reviewRating}
              totalRatingCount={hotel.reviewCount}
              dataId="ReviewRatingSummary"
              hotelId={hotel.objectID}
              singleLineLabels
            />
          </ReviewRatingButton>
        )}
        <CallToBook sourceComponent="AccommodationDesktopView" variant="AP" />
      </Box>
    </Box>
  )
}
